import { useCallback, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { fetchLookAlikeProducts as fetchLookAlikeProductsAction } from "app/pages/.shared/LookAlikeProduct/lookAlikeProductsActionCreators";
import LookAlikeSearchContent from "app/pages/.shared/LookAlikeProduct/LookAlikeSearchContent";
import AppGlobalsContext from "app/AppGlobalsContext";

const LookAlikeSearchContentContainer = ({ productId }) => {
	const dispatch = useDispatch();
	const fetchLookAlikeProducts = useCallback(
		(...args) => dispatch(fetchLookAlikeProductsAction(...args)),
		[dispatch]
	);
	const [products, setProducts] = useState([]);

	const { envVars = {} } = useContext(AppGlobalsContext);

	const navLogApiUrl = envVars.NAV_LOGS_API_URL;

	useEffect(() => {
		if (productId && navLogApiUrl) {
			fetchLookAlikeProducts(productId).then(res => {
				if (res.status === 200 && res.data && res.data.length > 0) {
					setProducts(res.data);
				}
			});
		}
	}, [productId, navLogApiUrl]);

	return <LookAlikeSearchContent products={products} />;
};

LookAlikeSearchContentContainer.propTypes = {
	productId: PropTypes.string,
};

export default LookAlikeSearchContentContainer;
